import React, { Component } from "react";

import { Container } from "reactstrap";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";

import {
  addLegalEntity,
  getLegalEntityProfile,
  setErrorLegalEntityProfile,
  updateLegalEntityProfile,
  setLegalEntityProfile,
} from "../../../../store/legal-entity/actions";
import LegalEntityInformationForm from "../AddLegalEntity/components/LegalEntityInformationForm";
import ModifiedMetaTags from '../../../../components/ModifiedMetaTags/index';

class LegalEntityProfile extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.getLegalEntityProfile(this.props.match.params.legalEntityId);
  }

  componentWillUnmount() {
    this.props.setErrorLegalEntityProfile(false);
    this.props.setLegalEntityProfile({});
  }

  render() {
    const legalEntityId = this.props.match.params.legalEntityId;
    const {
      addLegalEntity,
      updateLegalEntityProfile,
      legalEntityData,
      data,
      isError,
      history,
      profileLoader,
      permissions
    } = this.props;

    if (isError) {
      return <Redirect to={"/404"} />;
    }

    return (
      <React.Fragment>
        <div className="page-content">
        <ModifiedMetaTags title="Legal entity profile | Mobihunter" />
          <Container fluid>
            <Breadcrumbs
              title="Legal entity"
              breadcrumbItem={data?.counterparty_name}
              link="/legal-entity"
            />
            <LegalEntityInformationForm
              data={data}
              legalEntityData={legalEntityData}
              history={history} 
              permissions={permissions}
              addLegalEntity={addLegalEntity}
              updateLegalEntityProfile={updateLegalEntityProfile}
              legalEntityId={legalEntityId}
              loader={profileLoader}
            />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

LegalEntityProfile.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      legalEntityId: PropTypes.node,
    }).isRequired,
  }).isRequired,
  setErrorLegalEntityProfile: PropTypes.func.isRequired,
  updateLegalEntityProfile: PropTypes.func.isRequired,
  addLegalEntity: PropTypes.func.isRequired,
  getLegalEntityProfile: PropTypes.func.isRequired,
  setLegalEntityProfile: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  legalEntityData: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  profileLoader: PropTypes.bool.isRequired,
  isError: PropTypes.any,
  permissions: PropTypes.any,
};

const mapStateToProps = state => ({
  data: state.LegalEntityList.profileData,
  profileLoader: state.LegalEntityList.profileLoader,
  legalEntityData: state.LegalEntityList.data,
  isError: state.LegalEntityList.isError,
  permissions: state.User.permissions,
});

export default withRouter(
  connect(mapStateToProps, {
    addLegalEntity,
    getLegalEntityProfile,
    setErrorLegalEntityProfile,
    setLegalEntityProfile,
    updateLegalEntityProfile,
  })(LegalEntityProfile)
);
